import { createContext } from "react";
const DeliveryPincodeContext = createContext({});

export default DeliveryPincodeContext;
